import { mdiChartPie } from '@mdi/js'

export default {
  title: 'Dashboard',
  icon: mdiChartPie,
  resource: 'DashboardHeadDepartment',
  action: 'read',
  to: 'dashboard-hod',
}
